import adminList from './adminList'
import organizationList from './organizationList'
import permission from './permission'

export default {
  namespaced: true,
  modules: {
    adminList,
    organizationList,
    permission,
  },
}
